import {
  Text,
  Container,
  ActionIcon,
  Group,
  rem,
  Center,
  Anchor,
  SimpleGrid,
  Divider,
} from "@mantine/core";
import {
  IconBrandYoutube,
  IconBrandDiscord,
  IconBrandTwitch,
} from "@tabler/icons-react";
import Logo from "../Logo/Logo";
import classes from "./FooterLinks.module.css";
import { Link } from "react-scroll";
import { Legal } from "../Legal/Legal";
import { APPS } from "../../config/apps";
import site from "../../config/site.json";

// What each app in the family is for. Spelled out in the footer links so crawlers
// (and the AI answers built on them) learn which product belongs to which sim.
const APP_TOPICS: Record<string, string> = {
  "ACC DRIVE": "Assetto Corsa Competizione",
  "ACC ACADEMY": "ACC coaching",
  "iR DRIVE": "iRacing",
  "LMU DRIVE": "Le Mans Ultimate",
  "AC DRIVE": "Assetto Corsa",
  "ACE DRIVE": "Assetto Corsa EVO",
  "ACC TV": "ACC broadcasting",
  "LMU TV": "Le Mans Ultimate broadcasting",
};

const data = [
  {
    title: "About",
    links: [
      { label: "Home", id: "home" }
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Mirecourtstr. 8", id: "#" },
      { label: "53225 Bonn", id: "#" },
      { label: "Niklas Krause", id: "#" },
      { label: "Discord: MrPig100n", id: "#" },
    ],
  },
  {
    title: "Impressum",
    links: [
      { label: "", id: "imprint" },
      { label: "", id: "privacy_web" },
    ],
  },
];

export function FooterLinks() {
  const groups = data.map((group) => {
    const links = group.links.map((link, index) => {
      let linkElement;

      if (group.title === "About") {
        linkElement = (
          <Link key={index} to={link.id} className={classes.link}>
            <Text>{link.label}</Text>
          </Link>
        );
      } else if (group.title === "Impressum") {
        linkElement = (
          <Legal 
            key={index} 
            id={link.id}
            index={index}
          />
        );
      } else {
        linkElement = (
          <Text key={index} className={classes.nonLink}>
            {link.label}
          </Text>
        );
      }

      return linkElement;
    });

    return (
      <div className={classes.wrapper} key={group.title}>
        <Text className={classes.title}>{group.title}</Text>
        {links}
      </div>
    );
  });

  return (
    <Center>
      <footer className={classes.footer}>
        <SimpleGrid cols={{ base: 1, sm: 2, lg: 2 }} spacing={50} mt={30}>
          <Container className={classes.inner}>
            <div className={classes.logo}>
              <Logo />
              <Text size="xs" c="dimmed" className={classes.description}>
                All the Apps You Need - SimRacing SOLUTIONS
              </Text>
            </div>
          </Container>
          <Container>
            <SimpleGrid
              style={{ right: "50%" }}
              cols={{ base: 1, sm: 3, lg: 3 }}
            >
              {groups}
            </SimpleGrid>
          </Container>
        </SimpleGrid>
        <Divider my={"sm"} />

        <Container className={classes.family}>
          <Text c="dimmed" size="sm" ta="center">
            More sim racing apps from{" "}
            <Anchor href="https://simracingsolutions.de" c="dimmed" underline="always">
              SimRacing SOLUTIONS
            </Anchor>
          </Text>
          <Group gap="md" justify="center" mt="xs">
            {APPS.filter((app) => app.name !== site.name).map((app) => (
              <Anchor key={app.name} href={app.url} size="sm" c="dimmed">
                {APP_TOPICS[app.name] ? `${app.name} (${APP_TOPICS[app.name]})` : app.name}
              </Anchor>
            ))}
          </Group>
        </Container>

        <Container className={classes.afterFooter}>
          <Text c="dimmed" size="sm">
            © 2025 SimRacing SOLUTIONS. All rights reserved.
          </Text>

          <Group
            gap={0}
            className={classes.social}
            justify="flex-end"
            wrap="nowrap"
          >
            <Anchor href="https://dsc.gg/ACDRIVE" target="_blank">
            <ActionIcon size="lg" color="gray" variant="subtle">
              <IconBrandDiscord
                style={{ width: rem(18), height: rem(18) }}
                stroke={1.5}
              />
            </ActionIcon>
            </Anchor>
            <Anchor href="https://www.youtube.com/channel/UCbvxTXYQOvln58MpErXZZIA" target="_blank">
            <ActionIcon size="lg" color="gray" variant="subtle">
              <IconBrandYoutube
                style={{ width: rem(18), height: rem(18) }}
                stroke={1.5}
              />
            </ActionIcon>
            </Anchor>
            <Anchor href="https://www.twitch.tv/discostofftv" target="_blank">
            <ActionIcon size="lg" color="gray" variant="subtle">
              <IconBrandTwitch
                style={{ width: rem(18), height: rem(18) }}
                stroke={1.5}
              />
            </ActionIcon>
            </Anchor>
          </Group>
        </Container>
      </footer>
    </Center>
  );
}
